var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"chips-item d-inline-block",class:[
    {'chips-item--checked': _vm.checked},
    {'chips-item--disabled': _vm.disabled},
    {'chips-item--unselectable': _vm.unselectable}
  ],on:{"click":_vm.checkSelection}},[_c('span',{staticClass:"chips-item__text"},[_vm._t("default"),_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),(_vm.tooltip)?_c('span',{staticClass:"chips-item__tooltip"},[_vm._v(_vm._s(_vm.tooltip))]):_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }